<template>
    <div class="main">
        <van-loading size="26px" vertical type="spinner" color="#1989fa" v-if="!model_visible">获取中...</van-loading>

        <div v-if="model_visible">
            <div class="success-panel">
                <div class="title">恭喜，优惠券领取成功！</div>
            </div>
<!--            <div class="item-panel" v-for="(item,index) in myCouponList" :key="index">-->
<!--                <coupon-item :p_info="item" :p_show_button="false" />-->
<!--            </div>-->
            <coupon-item :p_info="current_coupon_item" :p_show_button="false" />
            <div>
                <van-button class="big-button" type="primary" @click="buy_it" :disabled="myCouponList.length===0">马上使用</van-button>
            </div>
        </div>

    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import store from '@/store';
    import config from '@/config';
    import CouponItem from "../../components/Coupon/CouponItem";

    export default {
        name: "DrawCoupon",
        components: {CouponItem},
        data(){
            return{
                link_id:this.$route.params.id,      //优惠券领取链接
                link_token:this.$route.params.token, //优惠券领取链接token
                openid:this.$store.getters.getLoginUser.openid, //当前购买客户的open_id
                client_id:this.$store.getters.getLoginUser.id,
                model_visible:false,
                myCouponList:[],
                current_coupon_item:{},
            }
        },
        methods:{
            ...mapActions([
                'DrawCoupon',
                'GetUserCouponList'
            ]),
            draw_coupon(){
                let p={
                    'client_uid':this.client_id,
                    'openid':this.openid,
                    'link_id':this.link_id,
                    'token':this.link_token
                };
                this.DrawCoupon(p).then(res=>{
                    if(res.status>0){
                        this.$Dialog.alert({message:res.msg}).then(()=>{
                            this.$router.push({name:'home'});
                        });
                    }else{
                        //成功——>弹出优惠券列表立即使用
                        this.myCouponList=res.responseObject;
                        console.log(this.myCouponList);
                        if(this.myCouponList.length>0){
                            this.current_coupon_item=this.myCouponList[0];   //hzh 2020-12-11 一次领用只显示当前这张优惠券记录
                        }
                        console.log('------- 优惠券返回对象 ---------');
                        console.log(this.current_coupon_item);
                        this.model_visible=true;
                    }
                });
            },
            buy_it(){
                //使用优惠券，直接进入订单创建页面
                // let ids='';
                // for(let i=0;i<this.myCouponList.length;i++){
                //     if(ids===''){
                //         ids=this.myCouponList[i].id;
                //     }else{
                //         ids+=','+this.myCouponList[i].id;
                //     }
                // }
                // let lock_area=1;
                // this.$router.push({name:'CreateOrderBatch',params:{ids,lock_area}});

                //采取单张购买处理模式
                console.log('优惠券对象:');
                console.log(this.current_coupon_item);
                let product_id=this.current_coupon_item.product_id;
                let sales_uid=this.current_coupon_item.sales_uid;
                this.$router.push({name:'CreateOrder',params:{product_id,sales_uid}});
            },
            loadMyCouponList(){
                let uid=this.client_id,mode=1;
                this.GetUserCouponList({uid,mode}).then(res=>{
                    this.myCouponList=res;
                    this.model_visible=true;
                    console.log(res);
                })
            }
        },
        mounted() {
             this.draw_coupon();
            document.body.style.backgroundColor='#F3F4F5';  //设置整页背景色
            //this.loadMyCouponList();
        },
        beforeRouteEnter(to, from, next){
            let loginUser = store.getters.getLoginUser;
            if(loginUser&&loginUser.openid){
                next();
            }else{
                //未登录，则发起微信登录授权
                let code = to.query.code;
                let sales_uid=to.params.sales_uid;
                let mode=1; //梅唐四季模式
                if(code){
                    store.dispatch('WeixinLogin',{code,sales_uid,mode}).then(res=>{
                        if(res.status>0){
                            //登录失败
                            next(false);
                        }else{
                            //成功
                            next();
                        }
                    });
                }else{
                    //无code则表示是第一次进入本页，发起微信授权
                    let redirect_uri = encodeURIComponent(window.location.href);
                    let appid=config.weixin.appid_mt;
                    let state=''; //'product-detail-sale/1004/1002'; //debug
                    let auth_url= 'https://open.weixin.qq.com/connect/oauth2/authorize?' +
                        'appid=' +appid+
                        '&redirect_uri=' +redirect_uri+
                        '&response_type=code&scope=snsapi_userinfo&' +
                        'state=' +state+
                        '#wechat_redirect';
                    window.location.href = auth_url;
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    .main{
        padding-top: 14px;
        text-align: center;
    }
    .item-panel{
        margin: 8px;
    }
    .big-button{
        width: 80%;
        border-radius: 10px;
    }
    .success-panel{
        text-align: center;
        .icon{
            font-size: 36px;
            color: #07C160;
            padding-top: 4px;
        }
        .title{
            font-size: 20px;
            color: #07C160;
            padding-bottom: 4px;
        }
        .text{
            font-size: 12px;
            color: #666666;
            padding-bottom: 4px;
        }
    }
</style>
